import React from 'react';
import { useHistory } from 'react-router-dom';
import { trackCreateUGCDraftCancel } from '../../../models/ugc-draft/analytics';
import FocusLock from 'react-focus-lock';
import Page, { PageMain, PageSidebar } from '../../../components/ui/page';
import BackButton from '../../../components/ui/back-button';
import useHeaderMinimizer from '../../../common/use-header-minimizer';
import Sidebar from './sidebar';
import UGCDraftForm from './form';
import { useTranslation } from 'react-i18next';
import {
  UgcDraftProvider,
  useUgcDraft,
} from '../../../models/ugc-draft/context';
import UGCDraftFormFields from './fields';

type BackButtonWrapperProps = {
  handleCancelClick: () => void;
};
const BackButtonWrapper = ({ handleCancelClick }: BackButtonWrapperProps) => {
  const { isPersisting, isLoading } = useUgcDraft();
  return (
    <BackButton
      isDisabled={isPersisting || isLoading}
      onClick={handleCancelClick}
    />
  );
};
const UGCDraftEdit = (props: { match: { params: { id?: string } } }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const objectId = props.match.params.id;

  const validId = objectId && objectId !== 'new' ? Number(objectId) : undefined;

  useHeaderMinimizer(true);

  const handleCancelClick = () => {
    history.goBack();
    trackCreateUGCDraftCancel();
  };

  return (
    <UgcDraftProvider id={validId}>
      <FocusLock>
        <div className={'content-submission-overlay-backdrop'} />
        <UGCDraftForm>
          {({ onSubmit }) => (
            <Page className="content-submission content-submission--post">
              <BackButtonWrapper handleCancelClick={handleCancelClick} />
              <PageMain aria-label={t('ugc_draft.main_area')}>
                <UGCDraftFormFields />
              </PageMain>
              <PageSidebar aria-label={t('ugc_draft.sidebar_area')}>
                <Sidebar onSubmit={onSubmit} />
              </PageSidebar>
            </Page>
          )}
        </UGCDraftForm>
      </FocusLock>
    </UgcDraftProvider>
  );
};

export default UGCDraftEdit;
